import { Notify } from 'quasar'
import type { QNotifyUpdateOptions } from 'quasar'
import { useAuthStore } from '~/stores/auth'

const isViewAsUserClasses = 'relative top-[3.5rem]'
export const notifySuccess = (
  message: string,
  options?: QNotifyUpdateOptions
) => {
  const AuthStore = useAuthStore()
  const isViewAsUser = AuthStore.isViewAsUser
  const groupClasses = `${isViewAsUserClasses}${
    options?.classes ? ` ${options?.classes}` : ''
  }`
  try {
    Notify?.create({
      color: 'primary',
      position: 'top',
      message,
      classes: isViewAsUser ? groupClasses : options?.classes,
      ...options,
    })
  } catch (error) {
    console.error('error', error)
  }
}

export const notifyFailure = (
  message: string,
  options?: QNotifyUpdateOptions
) => {
  const AuthStore = useAuthStore()
  const isViewAsUser = AuthStore.isViewAsUser
  const groupClasses = `${isViewAsUserClasses}${
    options?.classes ? ` ${options?.classes}` : ''
  }`
  try {
    Notify.create({
      color: 'negative',
      position: 'top',
      message,
      classes: isViewAsUser ? groupClasses : options?.classes,
      ...options,
    })
  } catch (error) {
    console.error('error', error)
  }
}

export const createSpinnerNotification = (
  message: string
): ReturnType<typeof Notify.create> =>
  Notify.create({
    position: 'top',
    timeout: 0,
    spinner: true,
    message,
    color: 'primary',
  })
